import React from 'react';
import styled, { css } from 'styled-components';
import Divider from '~/components/atom/Divider';
import layoutSizeToSystemSize from '~/components/template/EventTimelineV2/utils/layoutSizeToSystemSize';
import { DividerBlock, LayoutSize } from '~/graphql/types';

export type Props = Omit<DividerBlock, '__typename' | 'id'> & {
  dataTestId?: string;
  margin?: Array<LayoutSize | null | undefined> | undefined | null;
  css?: string | undefined | null;
};

const DividerBlockCmp: React.FC<Props> = ({ css, margin }) => (
  <Container
    color={{ group: 'tertiary', variant: 'light' }}
    margin={margin?.map(layoutSizeToSystemSize)}
    $css={css ?? undefined}
  />
);

const Container = styled(Divider)<{ $css?: string | null }>(
  ({ $css }) => css`
    ${$css &&
    css`
      ${$css}
    `}
  `,
);

export default DividerBlockCmp;
